var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "219px",
    height: "219px",
    viewBox: "0 0 219 219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 17.5,
    cy: 47.5,
    r: 7.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Third-ideation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "final",
    transform: "translate(-612.000000, -401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(612.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#2DCCD3",
    x: -2.84217094e-14,
    y: 0,
    width: 219,
    height: 219
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy",
    transform: "translate(41.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy",
    transform: "translate(24.000000, 0.000000)",
    stroke: "#23506A",
    strokeWidth: 0.65
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-71",
    fill: "#EAF6F9",
    x: 0.325,
    y: 0.325,
    width: 112.35,
    height: 89.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-79",
    fill: "#42BE9B",
    x: 0.325,
    y: 66.8467391,
    width: 112.35,
    height: 22.8282609
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(16.000000, 8.000000)",
    stroke: "#23506A",
    strokeWidth: 0.65
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-71",
    fill: "#EAF6F9",
    x: 0.325,
    y: 0.325,
    width: 112.35,
    height: 89.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-79",
    fill: "#42BE9B",
    x: 0.325,
    y: 66.8467391,
    width: 112.35,
    height: 22.8282609
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(8.000000, 16.000000)",
    stroke: "#23506A",
    strokeWidth: 0.65
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-71",
    fill: "#EAF6F9",
    x: 0.325,
    y: 0.325,
    width: 112.35,
    height: 89.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-79",
    fill: "#42BE9B",
    x: 0.325,
    y: 66.8467391,
    width: 112.35,
    height: 22.8282609
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-71",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 0.325,
    y: 24.325,
    width: 112.35,
    height: 89.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0851045,43.5993378 L109.40344,93.675 L44.7665991,93.675 L45.3993898,92.6939947 L19.5741348,92.6942256 L40.7819105,57.3622746 L53.9949928,79.3758403 L77.0851045,43.5993378 Z",
    id: "Combined-Shape-Copy",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#2DCCD3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-79",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#42BE9B",
    x: 0.325,
    y: 91.325,
    width: 112.35,
    height: 22.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#23506A",
    strokeWidth: 0.65,
    strokeLinejoin: "square",
    fill: "#F9BE00",
    fillRule: "evenodd",
    cx: 17.5,
    cy: 47.5,
    r: 7.175
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FBFCFB",
    strokeWidth: 1,
    cx: 17.5,
    cy: 47.5,
    r: 8
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome2);
export default __webpack_public_path__ + "static/media/Welcome2.5419c543df27e6bc8ab782ee48a01030.svg";
export { ForwardRef as ReactComponent };